/* dcnt. storefront behaviour */
(function () {
  // Scroll-in reveal: each [data-reveal] box fades up, then its bars fill (staggered in CSS)
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -12% 0px' }) : null;
  function reveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    document.documentElement.classList.add('d-anim');
    // wait two frames so the hidden start state paints before anything animates in
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      els.forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });
    }); });
  }

  function setCount(n) {
    document.querySelectorAll('[data-dcnt-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-n', n); });
  }

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function api(path, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(ROOT + path, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function vialHTML(c, k, w, h) {
    return '<span class="dv dv--' + esc(k) + '" style="--c:' + esc(c) + ';--w:' + w + 'px;--h:' + h + 'px" aria-hidden="true"><span class="dv__cap"></span><span class="dv__col"></span><span class="dv__body"><span class="dv__liq"></span><span class="dv__gloss"></span></span></span>';
  }
  var ICON = {
    trash: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
    minus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>'
  };

  // Cart drawer
  var drawer = (function () {
    var el = document.querySelector('[data-drawer]');
    if (!el) return null;
    var panel = el.querySelector('[data-drawer-panel]');
    var lines = el.querySelector('[data-lines]');
    var empty = el.querySelector('[data-empty]');
    var bar = el.querySelector('[data-shipbar]');
    var ups = el.querySelectorAll('[data-up]');
    var upsWrap = el.querySelector('[data-ups]');
    var checkout = el.querySelector('[data-checkout]');
    var fmt = el.getAttribute('data-money') || '₱{{amount}}';
    var meta = {};
    try { meta = JSON.parse((document.querySelector('[data-dcnt-meta]') || {}).textContent || '{}'); } catch (e) {}
    var lastFocus = null, known = {};

    function money(cents) {
      var n = cents / 100;
      var s = n.toLocaleString('en-PH', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
    }

    function lineHTML(it, fresh) {
      var m = meta[it.product_id] || {};
      var size = parseInt(it.variant_title, 10) || 100;
      var dims = size <= 5 ? [22, 54] : size <= 10 ? [26, 66] : [46, 52];
      var cap = size > 10 ? 'black' : (m.k || 'silver');
      var sale = it.original_line_price > it.final_line_price;
      return '<div class="d-line' + (fresh ? ' is-new' : '') + '" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
        '<a class="d-line__img" href="' + esc(it.url) + '" style="--t:' + esc(m.t || '#F5F5F7') + '" tabindex="-1" aria-hidden="true">' + vialHTML(m.c || '#F2BFCB', cap, dims[0], dims[1]) + '</a>' +
        '<div class="d-line__main">' +
          '<div class="d-line__t"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a> <span>' + esc(it.vendor) + '</span></div>' +
          (it.variant_title ? '<span class="d-line__size">' + esc(it.variant_title) + '</span>' : '') +
          '<div class="d-line__row">' +
            '<div class="d-qty">' +
              '<button type="button" data-dec aria-label="' + (it.quantity > 1 ? 'Remove one' : 'Remove ' + esc(it.product_title)) + '">' + (it.quantity > 1 ? ICON.minus : ICON.trash) + '</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-inc aria-label="Add one">' + ICON.plus + '</button>' +
            '</div>' +
            '<div class="d-line__price">' + (sale ? '<s>' + money(it.original_line_price) + '</s>' : '') + '<b' + (sale ? ' class="is-sale"' : '') + '>' + money(it.final_line_price) + '</b></div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    function render(cart) {
      setCount(cart.item_count);
      el.querySelectorAll('[data-drawer-count]').forEach(function (n) { n.textContent = cart.item_count; });
      var html = '', seen = {}, inCart = {};
      cart.items.forEach(function (it) {
        html += lineHTML(it, known.__init && !known[it.key]);
        seen[it.key] = 1; inCart[it.product_id] = 1;
      });
      seen.__init = 1; known = seen;
      lines.innerHTML = html;
      empty.hidden = cart.item_count > 0;
      if (checkout) checkout.disabled = cart.item_count === 0;

      var shown = 0;
      ups.forEach(function (u) { var hide = !!inCart[u.getAttribute('data-pid')] || shown >= 8; u.hidden = hide; if (!hide) shown++; });
      if (upsWrap) upsWrap.hidden = shown === 0;

      var sub = el.querySelector('[data-sub]'), was = el.querySelector('[data-sub-was]');
      var sale = cart.original_total_price > cart.total_price;
      sub.textContent = money(cart.total_price);
      sub.classList.toggle('is-sale', sale);
      was.hidden = !sale; if (sale) was.textContent = money(cart.original_total_price);

      if (bar) {
        var t = +bar.getAttribute('data-threshold'), left = t - cart.total_price;
        bar.classList.toggle('is-done', left <= 0);
        bar.querySelector('[data-shipbar-msg]').innerHTML = left > 0
          ? 'Add <b>' + money(left) + '</b> more for FREE shipping'
          : 'You’ve unlocked <b>FREE shipping</b> 🎉';
        bar.querySelector('[data-shipbar-fill]').style.width = Math.min(100, cart.total_price / t * 100) + '%';
      }
    }

    function refresh() { return api('cart.js').then(render); }

    function open() {
      lastFocus = document.activeElement;
      el.removeAttribute('inert'); el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('d-lock');
      requestAnimationFrame(function () { el.classList.add('is-open'); panel.focus({ preventScroll: true }); });
    }
    function close() {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true'); el.setAttribute('inert', '');
      document.documentElement.classList.remove('d-lock');
      panel.style.removeProperty('--drag');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function change(row, qty) {
      row.classList.add('is-busy');
      api('cart/change.js', { id: row.getAttribute('data-key'), quantity: qty })
        .then(render)
        .catch(function (e) {
          row.classList.remove('is-busy');
          var msg = row.querySelector('.d-line__err') || row.querySelector('.d-line__main').appendChild(document.createElement('div'));
          msg.className = 'd-line__err'; msg.textContent = (e && (e.description || e.message)) || 'Couldn’t update. Try again.';
        });
    }

    function add(id, qty) {
      return api('cart/add.js', { items: [{ id: Number(id), quantity: qty || 1 }] }).then(function () { return api('cart.js'); }).then(function (c) { render(c); return c; });
    }

    // events
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { close(); return; }
      var row = e.target.closest('.d-line');
      if (row && e.target.closest('[data-inc]')) { change(row, +row.getAttribute('data-qty') + 1); return; }
      if (row && e.target.closest('[data-dec]')) { change(row, +row.getAttribute('data-qty') - 1); return; }
      var b = e.target.closest('[data-up-add]');
      if (b) {
        b.disabled = true;
        add(b.getAttribute('data-up-add')).then(function () {
          b.innerHTML = ICON.check;
          el.querySelector('.d-drawer__body').scrollTo({ top: 0, behavior: 'smooth' });
        }).catch(function (err) {
          b.disabled = false;
          b.title = (err && err.description) || 'Sold out';
        });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cart-open]');
      if (!t) return;
      e.preventDefault(); refresh(); open();
    });

    // swipe the sheet down to close (mobile)
    var y0 = null, dy = 0;
    el.querySelectorAll('[data-drawer-grab]').forEach(function (g) {
      g.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; dy = 0; panel.classList.add('is-dragging'); }, { passive: true });
    });
    window.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      panel.style.setProperty('--drag', dy + 'px');
    }, { passive: true });
    window.addEventListener('touchend', function () {
      if (y0 === null) return;
      y0 = null; panel.classList.remove('is-dragging');
      if (dy > 90) close(); else panel.style.removeProperty('--drag');
    });

    // live counter: random number in [min,max] that drifts by ±1–2 every few seconds
    var live = el.querySelector('[data-live-counter]');
    if (live) {
      var ln = live.querySelector('[data-live-n]');
      var lo = +live.getAttribute('data-min') || 4, hi = Math.max(lo, +live.getAttribute('data-max') || 14);
      var cur = lo + Math.floor(Math.random() * (hi - lo + 1));
      var tick = function () {
        var step = (Math.random() < 0.5 ? -1 : 1) * (1 + Math.floor(Math.random() * 2));
        cur = Math.min(hi, Math.max(lo, cur + step));
        ln.textContent = cur; ln.classList.add('is-tick');
        setTimeout(function () { ln.classList.remove('is-tick'); }, 250);
        setTimeout(tick, 4000 + Math.random() * 5000);
      };
      ln.textContent = cur;
      setTimeout(tick, 4000 + Math.random() * 5000);
    }

    // keep in sync when the page is restored from the back/forward cache
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    refresh();
    return { open: open, close: close, render: render, add: add, refresh: refresh };
  })();
  window.dcntDrawer = drawer;

  // Mobile menu: drops down from under the header
  (function () {
    var btn = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-menu]');
    if (!btn || !menu) return;
    var scrim = document.querySelector('[data-menu-scrim]');
    var head = btn.closest('.d-head');
    function set(open) {
      btn.setAttribute('aria-expanded', open);
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
      menu.classList.toggle('is-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      if (head) head.classList.toggle('is-menu', open);
      document.documentElement.classList.toggle('d-lock-menu', open);
      if (open) { menu.removeAttribute('inert'); menu.setAttribute('aria-hidden', 'false'); }
      else { menu.setAttribute('inert', ''); menu.setAttribute('aria-hidden', 'true'); }
    }
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    if (scrim) scrim.addEventListener('click', function () { set(false); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-cart-open]')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) { set(false); btn.focus(); } });
    window.addEventListener('resize', function () { if (window.innerWidth > 749 && menu.classList.contains('is-open')) set(false); });
  })();

  function carousel(root) {
    var track = root.querySelector('[data-slides]');
    if (!track) return { go: function () {} };
    var n = track.children.length;
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var dots = root.querySelectorAll('.d-dots span');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var raf = 0;

    function idx() { return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / (track.clientWidth || 1)))); }
    function mark(i) {
      thumbs.forEach(function (t) { t.classList.toggle('is-on', t.dataset.thumb === String(i)); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      mark(i);
    }

    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; mark(idx()); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.thumb)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
    });

    // Mouse drag-to-swipe on desktop (touch already swipes natively)
    var down = false, startX = 0, startL = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startL = track.scrollLeft;
      track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startL - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (!down) return;
      down = false;
      var dx = e.clientX - startX, w = track.clientWidth, base = Math.round(startL / w);
      var target = Math.abs(dx) > w * 0.15 ? base + (dx < 0 ? 1 : -1) : base;
      track.style.scrollSnapType = ''; track.style.scrollBehavior = '';
      go(target);
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    window.addEventListener('resize', function () { track.scrollLeft = idx() * track.clientWidth; });
    mark(0);
    return { go: go };
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Roll a price to its new value: each changed character slides straight from old to new
  // (no counting through the numbers in between), staggered right-to-left with a soft overshoot.
  function tweenPrice(el, to) {
    var from = el.getAttribute('data-v') || el.textContent;
    clearTimeout(el._t);
    if (reduceMotion || from === to) { el.textContent = to; el.setAttribute('data-v', to); return; }
    var up = parseFloat(to.replace(/[^\d.]/g, '')) >= parseFloat(from.replace(/[^\d.]/g, ''));
    var pre = to.slice(0, Math.max(0, to.search(/\d/)));
    if (pre && from.indexOf(pre) === 0) { from = from.slice(pre.length); to = to.slice(pre.length); } else pre = '';
    var full = pre + to;
    var n = Math.max(from.length, to.length);
    var A = Array(n - from.length + 1).join('\u0000') + from, B = Array(n - to.length + 1).join('\u0000') + to;
    var html = '', step = 0;
    for (var i = n - 1; i >= 0; i--) {
      var o = A[i], c = B[i], cell;
      if (c === '\u0000') continue;
      if (o === c) cell = '<span class="d-dg">' + esc(c) + '</span>';
      else if (o === '\u0000') cell = '<span class="d-dg d-dg--in" style="--d:' + (step++ * 45) + 'ms">' + esc(c) + '</span>';
      else {
        var stack = up ? '<span>' + esc(o) + '</span><span>' + esc(c) + '</span>' : '<span>' + esc(c) + '</span><span>' + esc(o) + '</span>';
        cell = '<span class="d-dg ' + (up ? 'd-dg--up' : 'd-dg--down') + '" style="--d:' + (step++ * 45) + 'ms"><span class="d-dg__s">' + stack + '</span></span>';
      }
      html = cell + html;
    }
    if (pre) html = '<span class="d-dg">' + esc(pre) + '</span>' + html;
    el.setAttribute('data-v', full);
    el.classList.remove('is-go'); el.classList.add('d-roll');
    el.innerHTML = html;
    void el.offsetWidth;
    requestAnimationFrame(function () { el.classList.add('is-go'); });
    el._t = setTimeout(function () { el.classList.remove('d-roll', 'is-go'); el.textContent = full; }, 800 + step * 45);
  }

  // Build-your-3-pack sheet
  function bundle(sheet) {
    var panel = sheet.querySelector('[data-sheet-panel]');
    var slots = sheet.querySelectorAll('[data-bb-slot]');
    var items = sheet.querySelectorAll('[data-bb-item]');
    var fill = sheet.querySelector('[data-bb-fill]');
    var count = sheet.querySelector('[data-bb-count]');
    var total = sheet.querySelector('[data-bb-total]');
    var was = sheet.querySelector('[data-bb-was]');
    var save = sheet.querySelector('[data-bb-save]');
    var addBtn = sheet.querySelector('[data-bb-add]');
    var pack = +sheet.getAttribute('data-pack') || 79900;
    var fmt = sheet.getAttribute('data-money') || '₱{{amount}}';
    var picks = [], lastFocus = null, seeded = false, MAX = 3;
    function money(c) { return fmt.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toLocaleString('en-PH', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 })); }
    function byPid(pid) { for (var i = 0; i < items.length; i++) if (items[i].getAttribute('data-pid') === pid) return items[i]; }

    function render(popIdx) {
      slots.forEach(function (s, i) {
        var it = picks[i];
        s.classList.toggle('is-full', !!it);
        s.querySelectorAll('.dv,.d-bb__x,.d-bb__slot-name').forEach(function (n) { n.remove(); });
        if (it) {
          s.style.setProperty('--t', it.getAttribute('data-t'));
          s.insertAdjacentHTML('beforeend', vialHTML(it.getAttribute('data-c'), it.getAttribute('data-k'), 22, 46) +
            '<span class="d-bb__slot-name">' + esc(it.querySelector('.d-bb__name').textContent) + '</span>' +
            '<button type="button" class="d-bb__x" data-bb-remove="' + i + '" aria-label="Remove ' + esc(it.querySelector('.d-bb__name').textContent) + '"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>');
          if (i === popIdx) { s.classList.remove('is-pop'); void s.offsetWidth; s.classList.add('is-pop'); }
        } else s.style.removeProperty('--t');
      });
      items.forEach(function (it) { var on = picks.indexOf(it) > -1; it.classList.toggle('is-sel', on); it.setAttribute('aria-pressed', on); });
      fill.style.width = (picks.length / MAX * 100) + '%';
      count.textContent = picks.length + ' of ' + MAX + ' picked';
      var sum = picks.reduce(function (a, it) { return a + (+it.getAttribute('data-cents')); }, 0);
      var full = picks.length === MAX;
      total.textContent = money(pack);
      was.hidden = !(full && sum > pack); if (!was.hidden) was.textContent = money(sum);
      save.hidden = was.hidden; if (!save.hidden) save.textContent = 'You save ' + money(sum - pack) + ' vs buying separately';
      addBtn.disabled = !full;
      addBtn.textContent = full ? 'Add 3-pack to bag · ' + money(pack) : 'Pick ' + (MAX - picks.length) + ' more';
    }

    function toggle(it) {
      var i = picks.indexOf(it);
      if (i > -1) { picks.splice(i, 1); render(); return; }
      if (picks.length >= MAX) { it.classList.remove('is-shake'); void it.offsetWidth; it.classList.add('is-shake'); return; }
      picks.push(it); render(picks.length - 1);
    }

    function open() {
      if (!seeded) {
        seeded = true;
        var cur = byPid(sheet.getAttribute('data-current'));
        if (cur && !cur.disabled) picks.push(cur);
      }
      render();
      lastFocus = document.activeElement;
      sheet.removeAttribute('inert'); sheet.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('d-lock');
      requestAnimationFrame(function () { sheet.classList.add('is-open'); panel.focus({ preventScroll: true }); });
    }
    function close() {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true'); sheet.setAttribute('inert', '');
      document.documentElement.classList.remove('d-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-bundle-open]')) { e.preventDefault(); open(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) close(); });
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-sheet-close]')) { close(); return; }
      var rm = e.target.closest('[data-bb-remove]');
      if (rm) { picks.splice(+rm.getAttribute('data-bb-remove'), 1); render(); return; }
      var f = e.target.closest('[data-bb-filter]');
      if (f) {
        var g = f.getAttribute('data-bb-filter');
        sheet.querySelectorAll('[data-bb-filter]').forEach(function (b) { b.classList.toggle('is-on', b === f); });
        items.forEach(function (it) { it.hidden = g !== 'all' && it.getAttribute('data-g') !== g; });
        return;
      }
      var it = e.target.closest('[data-bb-item]');
      if (it && !it.disabled) toggle(it);
    });
    addBtn.addEventListener('click', function () {
      if (picks.length !== MAX) return;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      var tag = '3-pack ' + Date.now().toString(36);
      api('cart/add.js', { items: picks.map(function (it) { return { id: +it.getAttribute('data-vid'), quantity: 1, properties: { _bundle: tag } }; }) })
        .then(function () { return api('cart.js'); })
        .then(function (cart) {
          picks = []; seeded = false; close();
          if (drawer) { drawer.render(cart); setTimeout(drawer.open, 250); } else setCount(cart.item_count);
        })
        .catch(function (err) { addBtn.disabled = false; addBtn.textContent = (err && err.description) || 'Couldn’t add. Try again.'; });
    });
  }

  // UGC video strip: muted autoplay, only while on screen
  function ugc(sec) {
    var vids = Array.prototype.slice.call(sec.querySelectorAll('video'));
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    vids.forEach(function (v) {
      v.muted = true;
      var off = parseFloat(v.getAttribute('data-offset')) || 0;
      if (off) v.addEventListener('loadedmetadata', function () { if (v.duration) v.currentTime = off % v.duration; }, { once: true });
    });
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) play(e.target); else e.target.pause(); });
      }, { rootMargin: '0px 200px' });
      vids.forEach(function (v) { o.observe(v); });
    } else vids.forEach(play);
  }

  function pdp(root) {
    var form = root.querySelector('form[data-dcnt-form]');
    if (!form) return;
    var vial = root.querySelector('#d-vial');
    var addBtn = form.querySelector('[data-add]');
    var toast = root.querySelector('[data-toast]');
    var title = (root.querySelector('h1') || {}).textContent || '';
    var addHTML = addBtn ? addBtn.innerHTML : '';
    var slider = carousel(root);
    var first = true;
    function setBtn(t) { var l = addBtn.querySelector('[data-add-label]'); if (l) l.textContent = t; else addBtn.textContent = t; }

    function sync() {
      var r = form.querySelector('input[name="id"]:checked');
      if (!r) return;
      var animate = !first;
      root.querySelectorAll('[data-price]:not(input)').forEach(function (el) {
        if (animate) tweenPrice(el, r.dataset.price); else { el.textContent = r.dataset.price; el.setAttribute('data-v', r.dataset.price); }
      });
      root.querySelectorAll('[data-summary]').forEach(function (el) { el.textContent = title + ' · ' + r.dataset.title; });
      if (vial) {
        vial.style.setProperty('--w', r.dataset.w + 'px');
        vial.style.setProperty('--h', r.dataset.h + 'px');
        vial.className = 'dv dv--' + r.dataset.cap;
        var lbl = vial.querySelector('[data-vial-label]');
        if (lbl) lbl.textContent = r.dataset.title;
      }
      if (!first) slider.go(0); // show the vial resize when size changes
      first = false;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', r.value);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', sync);

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var r = form.querySelector('input[name="id"]:checked');
      if (!r) return;
      addBtn.disabled = true;
      setBtn('Adding…');
      var done = function (cart) {
        setCount(cart.item_count);
        setBtn('Added to Bag ✓');
        if (drawer) { drawer.render(cart); drawer.open(); }
        else if (toast) {
          toast.querySelector('[data-toast-msg]').textContent = title + ' · ' + r.dataset.title + ' added';
          toast.classList.add('is-on');
          setTimeout(function () { toast.classList.remove('is-on'); }, 3500);
        }
        setTimeout(function () { addBtn.innerHTML = addHTML; addBtn.disabled = false; first = true; sync(); }, 1200);
      };
      api('cart/add.js', { items: [{ id: Number(r.value), quantity: 1 }] })
        .then(function () { return api('cart.js'); })
        .then(done)
        .catch(function (err) {
          if (err && err.description) {
            setBtn(err.description);
            setTimeout(function () { addBtn.innerHTML = addHTML; addBtn.disabled = false; first = true; sync(); }, 2600);
          } else { form.submit(); }
        });
    });

    var bb = root.querySelector('[data-bundle-sheet]');
    if (bb) bundle(bb);

    var proxy = root.querySelector('[data-add-proxy]');
    if (proxy) proxy.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : addBtn.click(); });
    sync();
  }

  function init() {
    reveal();
    document.querySelectorAll('[data-dcnt-pdp]').forEach(pdp);
    document.querySelectorAll('[data-ugc]').forEach(ugc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
